import axios from 'axios'
import type { LoadSortPresetKey } from '@numeo/types'

interface Envelope<T> {
    success: boolean
    data: T
    message?: string
}

export const mobileLoadSortApi = {
    get: async (): Promise<LoadSortPresetKey> => {
        const res = await axios.get<Envelope<{ defaultPreset: LoadSortPresetKey }>>('/gluon/config/mobile-load-sort')
        return res.data.data.defaultPreset
    },

    setDefault: async (defaultPreset: LoadSortPresetKey): Promise<LoadSortPresetKey> => {
        const res = await axios.put<Envelope<{ defaultPreset: LoadSortPresetKey }>>('/gluon/config/mobile-load-sort', { defaultPreset })
        return res.data.data.defaultPreset
    },
}
